/* omw-envio-estimado.js — CRO-002 · Oh My Wood! · 23-09-2026
   (sustituye la v1 de CRO-001)

   Rellena el coste de envío a península en el carrito, sin pedir datos al cliente.

   QUÉ CAMBIA FRENTE A LA v1:

   a) Pinta TODAS las cajas de la página, no solo la primera. En /cart conviven la
      página del carrito y el drawer, así que hay dos. La v1 usaba querySelector y
      dejaba el drawer vacío.

   b) Una sola petición para todas. El carrito es el mismo, la tarifa también.

   c) MutationObserver además de los eventos. Al añadir un producto, el drawer se
      repinta con renderContents() y NO dispara 'afterUpdateQuantity': solo llama a
      open(). Sin el observer, la fila del drawer nacería vacía.
      No hay bucle: cada caja se marca con data-omw-listo en cuanto se lanza su
      petición, y el observador sale de inmediato si no queda ninguna sin marcar.

   d) Guarda anti-doble-carga. El asset se referencia desde main-cart y desde
      cart-drawer; en /cart eso son dos <script> al mismo fichero.

   TRES DECISIONES QUE SE MANTIENEN DE LA v1:

   1. Tarifa REAL, no fijada a mano: /cart/shipping_rates.json, el mismo endpoint de
      la calculadora del tema. Si se cambia el precio en Shopify, esta línea se
      actualiza sola. Un importe escrito a mano se quedaría obsoleto, y mostrar un
      precio de envío falso además es un problema legal.

   2. Se reengancha tras cada cambio de carrito.

   3. Falla en silencio. Si no hay respuesta o no hay tarifas, la fila sigue oculta y
      el carrito queda como antes. Nunca se muestra un importe inventado.

   NO toca Teeinblue.                                                                 */
(function () {
  'use strict';

  if (window.__omwEnvioCargado) return;        /* el asset se incluye dos veces en /cart */
  window.__omwEnvioCargado = true;

  var PENDIENTES = '[data-omw-envio]:not([data-omw-listo])';

  function dinero(centimos) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme
          && theme.moneyFormat) {
        return Shopify.formatMoney(centimos, theme.moneyFormat);
      }
    } catch (e) { /* se cae al formato manual */ }
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function pintar(caja, texto, gratis) {
    var valor = caja.querySelector('[data-omw-envio-valor]');
    if (!valor) return;
    valor.textContent = texto;
    caja.classList.toggle('omw-envio--gratis', !!gratis);
    caja.removeAttribute('hidden');
  }

  function calcular() {
    var cajas = document.querySelectorAll(PENDIENTES);
    if (!cajas.length) return;

    /* Se marcan ANTES de pedir: así el observador no vuelve a entrar mientras la
       petición viaja, y una caja que falle no se reintenta en bucle. */
    Array.prototype.forEach.call(cajas, function (c) { c.setAttribute('data-omw-listo', '1'); });

    var ref = cajas[0];
    var q = 'shipping_address[country]='   + encodeURIComponent(ref.dataset.pais || 'ES')
          + '&shipping_address[province]=' + encodeURIComponent(ref.dataset.provincia || '')
          + '&shipping_address[zip]='      + encodeURIComponent(ref.dataset.cp || '');

    fetch('/cart/shipping_rates.json?' + q, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.shipping_rates || !d.shipping_rates.length) return;   // silencio
        /* El endpoint devuelve el precio en euros como cadena ("3.95"), no en céntimos. */
        var mas_barata = d.shipping_rates.reduce(function (a, b) {
          return parseFloat(b.price) < parseFloat(a.price) ? b : a;
        });
        var centimos = Math.round(parseFloat(mas_barata.price) * 100);
        if (isNaN(centimos)) return;
        var gratis = centimos === 0;
        Array.prototype.forEach.call(cajas, function (c) {
          pintar(c, gratis ? 'Gratis' : dinero(centimos), gratis);
        });
      })
      .catch(function () { /* silencio */ });
  }

  var timer = null;
  function recalcular() {
    clearTimeout(timer);
    timer = setTimeout(calcular, 80);
  }

  function iniciar() {
    calcular();

    /* El tema repinta el bloque de totales desde el servidor y avisa con este evento. */
    document.addEventListener('afterUpdateQuantity', recalcular);
    document.addEventListener('afterCartChanged',    recalcular);

    /* Y el drawer se repinta sin avisar. Observar su contenedor y el de la página del
       carrito es más barato que observar el body entero, que Teeinblue muta sin parar. */
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (document.querySelector(PENDIENTES)) recalcular();
    });
    ['cart-drawer', '#MainContent', '.cart__footer'].forEach(function (sel) {
      var raiz = document.querySelector(sel);
      if (raiz) obs.observe(raiz, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else { iniciar(); }
})();
